import { useEffect } from "react";
import { Dimmer, Loader } from "semantic-ui-react";

import { MainContentLoginLayout } from "../components/index";

import { useLocation } from "react-router-dom";
import { usePostUserDetails } from "../api/userDetails";
import { notificationSetupService } from "../config/firebase";
import { sendNativeNotification, toastNotification } from "../hooks/notificationHelpers";
import { useAuthContext } from "../hooks/useAuthContext";
import useVisibilityChange from "../hooks/useVisibilityChange";
import "./mainContanier.scss";
import { MainContentViewLayout } from "./mainLayout/MainContentViewLayout";

const publicRoutes = ["/auth", "/logout", "/password-reset", "/password-forgot", "/unauthorized"];

export const MainContentLayout = ({ children }: any) => {
  const location = useLocation();
  const isForeground = useVisibilityChange();
  var currentPath = location.pathname;
  const { dispatch } = useAuthContext();

  //custom hook
  const {
    data: userProfileData,
    isLoading,
    mutate: loadUserData,
    isSuccess: isSuccessLoadData
  } = usePostUserDetails();

  //load user details
  useEffect(() => {
    if (localStorage.getItem("IdToken")) {
      loadUserData("", {
        onSuccess() {
          publicRoutes.includes(currentPath) && window.location.replace("/");
        }
      });
    }
  }, []);

  //save user data in context
  useEffect(() => {
    if (isSuccessLoadData) {
      dispatch({ type: "LOGIN", payload: userProfileData });
      requestPermission(userProfileData);
    }
  }, [isSuccessLoadData]);

  const checkUserAuth = () => {
    return publicRoutes.includes(currentPath);
  };

  const requestPermission = async (userProfileData: any) => {
    notificationSetupService.setup(userProfileData, (message: any) => {
      if (isForeground) {
        // App is in the foreground, show toast notification
        toastNotification({
          title: message.notification.title,
          body: message.notification.body
        });
      } else {
        // App is in the background, show native notification
        sendNativeNotification({
          title: message.notification.title,
          description: message.notification.body
        });
      }
      dispatch({ type: "NEW_NOTIFICATION" });
    });
  };

  //handle loading
  if (isLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return checkUserAuth() ? (
    <MainContentLoginLayout children={children} />
  ) : (
    <MainContentViewLayout currentPath={currentPath} children={children} />
  );
};
